import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Field, reduxForm} from 'redux-form'
import ValidatedCustomInput from "views/Components/ValidatedCustomInput.jsx"
import DropdownSimple from "views/Components/DropdownSimple.jsx"

import withStyles from "@material-ui/core/styles/withStyles";
import styles from "assets/jss/material-dashboard-pro-react/views/form";
import _ from 'lodash'
// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
// import IconButton from '@material-ui/core/IconButton';
import CancelIcon from "@material-ui/icons/Cancel";
//import EditIcon from '@material-ui/icons/Edit'
//import Actions from 'views/Tables/Actions'
//import Table from "components/Table/Table.jsx";
import LinearProgress from '@material-ui/core/LinearProgress';
import {crPerType} from 'enums'
import {required} from 'views/utils/validations'
import {formatToSelectValues} from 'views/utils/helpers'

import {
  danger,
  success,
} from 'actions/notification'


import {
  profileSpecialCaseSave,
  profileSpecialCasesFetch,
	profileSpecialCaseFetch,
	profileSpecialCaseRemove
} from 'actions/profileSpecialCases'

import {
	symbolsFetch,
	symbolFilter
} from 'actions/symbols'

import {
  currenciesFetch,
  currencyFilter
} from 'actions/currencies'

const inputStyle = {
	width: '100%'
}

const tableStyle = {
	width: '100%',
	tableLayout: 'fixed',
}

const theadStyle = {
	display: 'block',
	borderBottom: '1px solid gray',
	textAlign: 'center'
}

const tbodyStyle = {
	display: 'block',
	tableLayout: 'fixed',
	width: '100%',
	overflow: 'auto',
	height: '500px'
}

const trStyle = {
	borderBottom: '1px solid #EEEEEE',
	display: 'table',
	width: '100%'
}

const trHeadStyle = {
	display: 'table',
	minWidth: '100%'
}

const tdStyle = {
	height: '40px',
}

class SpecialCase extends Component {
		state= {
			form: {},
			filterSymbol: ''
		}

		componentDidMount() {
			this.props.currencyFilter({size: 100000})
    	this.props.currenciesFetch()
			this.props.symbolsFilter({size: 100000})
			this.props.fetchAll(this.props.match.params.id).then((cases) => {
				this.props.symbolsFetch().then((data) => {
						this.setForm(data.content, cases)
				})
			})
			
		}
		setForm(data, cases) {
			let formData = {}
			data.forEach((s) => {
				let specialCase = cases.find((i) => i.symbols[0].symbolId === s.symbolId)
				formData[s.name] = {
						symbolId: s.symbolId,
						symbolName: s.name,
						profileSpecialCaseId: specialCase ? specialCase.profileSpecialCaseId : '',
						markup: specialCase ? specialCase.markup : '',
						//mrPerType: specialCase ? specialCase.mrPerType : 'PERLOT',
						commission: specialCase ? specialCase.commission : '',
						commissionType: specialCase ? specialCase.commissionType : '',
						commissionCurrencyId: specialCase ? specialCase.commissionCurrencyId : '',
						//crPerType: specialCase ? specialCase.crPerType : 'PERLOT',
						spread: specialCase ? specialCase.spread : '',
						percentage: specialCase ? specialCase.percentage : '',
						save: false,
						editMode: false
				}
			})
						
			this.setState({
				...this.state,
				form: formData
			})
		}
		delete(id){
			const profileId = this.props.match.params.id
			this.props.remove(profileId, id)
				.then(e=>{
					this.props.success(id + ' Removed!',4);
					this.props.fetchAll(this.props.match.params.id).then((cases) => {
						this.setForm(this.props.symbols.list, cases)
					})
				})
				.catch(e=>{this.props.danger(e+'',4);})
		}

		getInput(data) {
			return <Field
							name={data.key}
							placeholder={data.name}
							id={data.key}
							icon={data.icon}
							type={data.type}
							props={{
								name: data.key
							}}
							validate={data.required ? [required] : []}
							component={ValidatedCustomInput}
						/>
		}
		submit(values){
			const profileId = this.props.match.params.id
			values.symbols = [values.symbolId]
			if(values.commissionCurrencyId === '') {
				delete values.commissionCurrencyId
			} else {
				values.commissionCurrencyId = Number(values.commissionCurrencyId)
			}

			if(values.commissionType === '') {
				delete values.commissionType
			}
			
			this.props.save(profileId, values)
				.then(e=>{
					this.props.success(e.profileSpecialCaseId + (values.profileSpecialCaseId ? ' Edited!' :' Created!'),4);
					this.props.fetchAll(this.props.match.params.id).then((cases) => {
						this.setForm(this.props.symbols.list, cases)
					})
				})
				.catch(e=>{this.props.danger(e+'',4);})
		}
		save(){
			const invalid  = Object.values(this.state.form).filter((x) => x.editMode && !x.save)
			if (invalid.length !== 0) {
				let form = this.state.form
				invalid.forEach((s) => {
					form[s.symbolName].validationError = true
				})
				this.setState({...this.state, form: form})
				return
			}
			Object.values(this.state.form).forEach((s) => {
				if(s.save) this.submit(s)
			})
		}
		checkValues(specialCase){
			return (specialCase.commission && specialCase.commissionType)
				|| specialCase.markup
				|| specialCase.spread
				|| specialCase.percentage
		}
		checkEditValues(specialCase){
			return specialCase.markup
				|| specialCase.commission
				|| specialCase.commissionType
				|| specialCase.spread
				|| specialCase.percentage
		}
		changeValue(e, symbol, prop) {
			let form = this.state.form
			form[symbol][prop] = e.target.value
			form[symbol].save = this.checkValues(form[symbol]) !== ''
			form[symbol].editMode = this.checkEditValues(form[symbol]) !== ''
			if((!form[symbol].save && form[symbol].editMode === false)
				|| (form[symbol].save && form[symbol].editMode)) {
				form[symbol].validationError = false
			}
			this.setState({
				...this.state,
				form: form
			})
		}
		filter(filter){
			this.setState({...this.state,selected:[]})
			this.props.symbolsFilter({
				...this.props.symbols.pageable,
				...filter,
				page: filter.size 
					? 0 
					: filter.page !== undefined ? filter.page : this.props.symbols.pageable.page
			})
			this.props.symbolsFetch().then((data) => {
				this.setForm(data.content, this.props.profileSpecialCases.list)
			})
		}
		clear(){
			
			this.setForm(this.props.symbols.list, this.props.profileSpecialCases.list)
		}
		searchSymbol(e){
			this.setState({...this.state, filterSymbol:e.target.value.toUpperCase()})
		}
    render(){
			const {classes, profileSpecialCases, symbols, currencies} = this.props
			const currencyOptions = currencies.map((i) => {return {value: i.currencyId, label: i.name}})
      return(
			<GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <Card>
            <CardBody>
							<div>
								
								<div style={{float:'left', display:'inline-block'}}>
									<input style={{marginTop:'25px', padding:'5px'}}
										placeholder="Search symbol" value={this.state.filterSymbol} onChange={(e)=>this.searchSymbol(e)} />
								</div>
								<div style={{float:'right', display:'inline-block'}}>
									<Button
										type="button"
										onClick={e =>this.save(e)}
										className={classes.submit}
										color="success"
									>
										SAVE
									</Button>

									<Button
										type="button"
										onClick={e =>this.clear(e)}
										className={classes.submit}
										color="warning"
									>
										Clear
									</Button>
								</div>
								
		
								<GridContainer justify="center">		
									<GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={12}>

									{(profileSpecialCases.isFetching || symbols.isFetching)
									? <LinearProgress color="primary"/>
									: (
										
										<table style={tableStyle}>
											<thead style={theadStyle}>
												<tr style={trHeadStyle}>
													<th style={{width:'105px'}}>Symbol</th>
													<th style={{width:'15%'}}>Commission Rebate</th>
													<th style={{width:'10%'}}>Commission Rebate Currency</th>
													<th style={{width:'10%'}}>Commission Type</th>
													<th style={{width:'15%'}}>Markup Rebate</th>
													<th style={{width:'15%'}}>Percentage Rebate</th>
													<th style={{width:'10%'}}>Spread</th>
													<th style={{width:'50px', paddingRight: '20px'}}>Actions</th>
												</tr>
											</thead>
											<tbody style={tbodyStyle}>
												{_(this.state.form).orderBy((i) => i.profileSpecialCaseId, ['desc']).value().filter(x=> x.symbolName.toUpperCase().includes(this.state.filterSymbol)).map((vals,i) => {
													const error = vals.validationError
													return (
													<tr style={{...trStyle}} key={i}>
														<td style={{...tdStyle, width:'105px'}}>{vals.symbolName}</td>
														<td style={{...tdStyle, width:'15%'}}><input style={inputStyle} onChange={(e) => this.changeValue(e, vals.symbolName, 'commission')} value={vals.commission} /></td>
														<td style={{...tdStyle, width:'10%'}}><DropdownSimple options={currencyOptions} meta={{}} input={{onChange:(e)=> this.changeValue(e, vals.symbolName, 'commissionCurrencyId'), value: vals.commissionCurrencyId}} /></td>
														<td style={{...tdStyle, width:'10%'}}><DropdownSimple options={formatToSelectValues(crPerType)} meta={{}} input={{onChange:(e)=> this.changeValue(e, vals.symbolName, 'commissionType'), value: vals.commissionType}} /></td>
														<td style={{...tdStyle, width:'15%'}}><input type="number" style={inputStyle} onChange={(e) => this.changeValue(e, vals.symbolName, 'markup')} value={vals.markup} /></td>
														<td style={{...tdStyle, width:'15%'}}><input type="number" style={inputStyle} onChange={(e) => this.changeValue(e, vals.symbolName, 'percentage')} value={vals.percentage} /></td>
														<td style={{...tdStyle, width:'10%'}}><input style={inputStyle} onChange={(e) => this.changeValue(e, vals.symbolName, 'spread')} value={vals.spread} /></td>
														<td style={{...tdStyle, width:'50px'}}>
															{vals.profileSpecialCaseId &&
																<div style={{textAlign: 'center'}}>
																	<CancelIcon
																		onClick={ev =>this.delete(vals.profileSpecialCaseId)}
																		style={{cursor: 'pointer',color: '#f44336'}}
																	/>
																</div>
															}
														</td>
														{error &&<td style={{display: 'table-row', color:'red', fontSize:'11px', fontStyle:'italic', width:'100%'}}>
															Please fill fields
														</td>}
													</tr>
													)
												})}
											</tbody>
										</table>
										)}
										
									</GridItem>
								</GridContainer>
							</div>
          	</CardBody>
				</Card>
			</GridItem>
		</GridContainer>
    )
  }
}

function mapStateToProps(state) {
	return {
		profileSpecialCases: state.profileSpecialCases,
		symbols: state.symbols,
		currencies: state.currencies.list,
	}
}

function mapDispatchToProps(dispatch) {
	return {
		fetch:(profileSpecialCaseId)=>dispatch(profileSpecialCaseFetch(profileSpecialCaseId)),
  	fetchAll:(profileId)=>dispatch(profileSpecialCasesFetch(profileId)),
		save:(profileId, data)=>dispatch(profileSpecialCaseSave(profileId, data)),
		remove: (profileId, id) => dispatch(profileSpecialCaseRemove(profileId, id)),
		danger:(text,sec)=>dispatch(danger(text,sec)),
		success:(text,sec)=>dispatch(success(text,sec)),
		symbolsFetch: () => dispatch(symbolsFetch()),
		symbolsFilter: (filter) => dispatch(symbolFilter(filter)),
		currenciesFetch: () => dispatch(currenciesFetch()),
		currencyFilter: (filter) => dispatch(currencyFilter(filter))
	}
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(reduxForm({ form: 'createProfileSpecialCaseForm' })(SpecialCase)))



// WEBPACK FOOTER //
// ./src/views/Profiles/SpecialCase.jsx